module.exports = __webpack_public_path__ + "static/media/black.e0845d1c.png";